import textModule from './text.module';
export default textModule;
